import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, BrandMark } from '../ui';
import { FOOTER_LINKS, SALES_EMAIL, SALES_PHONE, SALES_PHONE_HREF } from '../../data/marketing';

// CTA band + modern footer.
const SiteFooter = ({ onRequestDemo }) => (
  <footer className="bg-brand-950 text-white">
    {/* CTA band */}
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-brand-mesh opacity-70" />
      <Container className="relative py-16 sm:py-20 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold font-display max-w-2xl mx-auto leading-tight">
          Ready to bring your district into one platform?
        </h2>
        <p className="mt-3 text-brand-100 max-w-xl mx-auto">
          See a live demo branded for your schools - or get your athletic and fine arts staff selling tickets this week.
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button onClick={onRequestDemo} variant="accent" size="lg" className="w-full sm:w-auto">Request a demo</Button>
          <Button href={`mailto:${SALES_EMAIL}?subject=${encodeURIComponent('Valley Tickets - Contact Sales')}`} variant="white" size="lg" className="w-full sm:w-auto">Contact sales</Button>
        </div>
      </Container>
    </div>

    {/* Links */}
    <div className="border-t border-white/10">
      <Container className="py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <BrandMark layout="horizontal" className="h-9 text-white mb-3" />
            <p className="text-sm text-brand-200 max-w-xs">
              RGV-built ticketing for school districts: athletics, fine arts, tournaments, and community events across the Rio Grande Valley.
            </p>
            <div className="mt-4 space-y-1.5 text-sm">
              <a href={`tel:${SALES_PHONE_HREF}`} className="block text-brand-100 hover:text-white">📞 {SALES_PHONE}</a>
              <a href={`mailto:${SALES_EMAIL}`} className="block text-brand-100 hover:text-white break-all">✉️ {SALES_EMAIL}</a>
            </div>
          </div>
          {FOOTER_LINKS.map((col) => (
            <div key={col.heading}>
              <h4 className="text-sm font-semibold text-white mb-3">{col.heading}</h4>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-brand-200 hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </div>

    <div className="border-t border-white/10">
      <Container className="py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-brand-300">
        <p>© {2026} Valley Tickets · RGV-built. All rights reserved.</p>
        <p>🗣️ Hablamos español — support available upon request</p>
      </Container>
    </div>
  </footer>
);

export default SiteFooter;
